// extracted by mini-css-extract-plugin
export var askAiIcon = "_m0-j";
export var category = "_m0-9";
export var categoryHeader = "_m0-e";
export var container = "_m0-0";
export var group = "_m0-a";
export var groupItems = "_m0-f";
export var groupSeparator = "_m0-k";
export var loading = "_m0-1";
export var noResults = "_m0-3";
export var placeholder = "_m0-2";
export var resultContent = "_m0-5";
export var resultIcon = "_m0-c";
export var resultItem = "_m0-g";
export var resultMeta = "_m0-8";
export var resultSubtitle = "_m0-7";
export var resultSuffix = "_m0-i";
export var resultTitle = "_m0-6";
export var resultsList = "_m0-4";
export var searchGroup = "_m0-d";
export var selected = "_m0-h";
export var subgroup = "_m0-b";